import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrButton, {
  SR_BUTTON_FONT_SIZE_MEDIUM,
  SR_BUTTON_HEIGHT_TALL,
  SR_BUTTON_THEME_ADOBE_WHITE_SHADOW,
} from 'client/components/SrButton/SrButton';

const SrUtilitySetupTransferInternetButton = ({ onClick = () => {} }) => {
  return (
    <SrButton
      theme={SR_BUTTON_THEME_ADOBE_WHITE_SHADOW}
      heightType={SR_BUTTON_HEIGHT_TALL}
      fontSizeType={SR_BUTTON_FONT_SIZE_MEDIUM}
      onClick={onClick}
      wrapText
    >
      <SrBox display="flex" alignItems="center" justifyContent="center">
        Transfer my current internet
        <SrBox
          width="10px"
          height="10px"
          marginLeft="8px"
          marginTop="2px"
          backgroundSize="10px"
          backgroundRepeat="no-repeat"
          backgroundPosition="center"
          backgroundImage="url(/images/arrow-right-blue-rounded-medium.svg)"
        />
      </SrBox>
    </SrButton>
  );
};

SrUtilitySetupTransferInternetButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

SrUtilitySetupTransferInternetButton.displayName = 'SrUtilitySetupTransferInternetButton';

export default SrUtilitySetupTransferInternetButton;
